$(document).ready(function() {

  const delivery_timer = setInterval(deliverytimer, 1000);
    function deliverytimer() {
      $(".inner_all_grid_rpeater").each(function() {
      var get_value = $(this).find(".skio-group-container input:checked").val();
        if(get_value !== ''){
          var selected_value = $(this).find(".skio-group-container input:checked").parents(".skio-group-container").find(".skio-frequency select").html();
          $(this).find(".delivery_select_wrapper select.delivery_dropdown").html(selected_value);
          $(this).find(".CustomSubscription").show();
          $(this).find(".DeliveryHead").html("Deliver Every");
          var data_value = $(this).find(".delivery_select_wrapper select.delivery_dropdown option:selected").val();
          $(this).find(".colection_page_selling").val(data_value);
        }
      });
          clearInterval(delivery_timer);
    }
  
  $(document).on("change",".inner_all_grid_rpeater .skio-group-container input.skio-group-input", function() {
    var get_value = $(this).val();
      if(get_value !== ''){
        var selected_value = $(this).parents(".skio-group-container").find(".skio-frequency select").html();
        $(this).parents(".inner_all_grid_rpeater").find(".delivery_select_wrapper select.delivery_dropdown").html(selected_value);
        $(this).parents(".inner_all_grid_rpeater").find(".DeliveryHead").html("Deliver Every");
        $(this).parents(".inner_all_grid_rpeater").find(".CustomSubscription").show();
      }else{
        $(this).parents(".inner_all_grid_rpeater").find(".DeliveryHead").html("");
        $(this).parents(".inner_all_grid_rpeater").find(".CustomSubscription").hide();
      }
    });
    
  $(document).on("change",".inner_all_grid_rpeater .qty_deleviry_data_wrapp .delivery_select_wrapper select", function() {
    var data_change = $(this).val(); 
    $(this).parents(".inner_all_grid_rpeater").find(".colection_page_selling").val(data_change);
  });
  
  $(document).on('click','.subscription_cart-btn-wrapp .Quantity_box button.quantity__button[name=plus]',function(){
    var get_val =  parseInt( $(this).parents(".quantity").find("input").val()) + parseInt("1");
    var text = $(this).parents(".quantity").find("input").val(get_val);
    $(this).parents(".inner_all_grid_rpeater").find(".product-variant-qty").val(get_val);
  });
    
  $(document).on('click','.subscription_cart-btn-wrapp .Quantity_box button.quantity__button[name=minus]',function(){
    var get_val =parseInt( $(this).parents(".quantity").find("input").val()) - parseInt("1");
      if(get_val != 0){
         $(this).parents(".quantity").find("input").val(get_val);   
         $(this).parents(".inner_all_grid_rpeater").find(".product-variant-qty").val(get_val);
       }
       if(get_val < 2){
          $(this).addClass('disabled');
       }else{
          $(this).removeClass('disabled');
       }
  });
    
  $(".custom_feapro_wrapper li.inner_all_grid_rpeater").each(function() {
   var data_value = $(this).find(".skio-group-container .main_col_title-wrapper .skio-frequency select option:selected").val();
    $(this).find(".colection_page_selling").val(data_value);
  }); 
  
  $(".custom_feapro_wrapper .skio-group-container input").change(function() {
    if ($(this).hasClass("one_time_perchase")) {
      $(this).parents(".inner_all_grid_rpeater").find(".colection_page_selling").val('');
    }else{
      var data_value = $(this).parents(".skio-group-container").find(".main_col_title-wrapper .skio-frequency select option:selected").val();
      $(this).parents(".inner_all_grid_rpeater").find(".colection_page_selling").val(data_value);
    }
  });
  
  
  $(document).on('click','.CUstomPlus',function(e){
    e.preventDefault();
    let formData;
    var MapVariantId =  $(this).parents('.cart-quantity').attr('data-id');
    var getval = $(this).parents('.cart-quantity').children('.VariantOptions').children('.objectWrapElem').children('.CustomCartvarinat:visible').next().attr('value');
      if(typeof getval !== 'undefined'){
       $(this).parents('.cart-quantity').children('.VariantOptions').children('.objectWrapElem').children('.CustomCartvarinat').hide();
       $(this).parents('.cart-quantity').find('.VariantOptions').children('.objectWrapElem').children('.CustomCartvarinat[value="'+getval+'"]').show();     
       var custom = '';
       $(this).parents('.cart-quantity').find(".CustomVariantstxt").each(function () {
       var getatt = $(this).find('.Custonvariantoptions:visible').attr('value');
       custom += getatt + ' / ';
      });
        
      var slicevalue = custom.slice(0,-2).trim();
      var selectval =  $(this).parents('.cart-quantity').find('.SelectedVariants option[data-title="'+slicevalue+'"]').val();
      var ProductHandle = $(this).attr('data-url');
      var sellingplan =   $(this).parents('.cart-quantity').attr('selleing-id');
        
      let updates = { [MapVariantId]: 0};
        fetch(window.Shopify.routes.root + 'cart/update.js', {
               method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates }),
              })
              .then(response => {
                return response.json();
              })
              .finally(() =>{
               
              fetch(window.Shopify.routes.root + 'products/'+ProductHandle+'.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(productJson => {
                return productJson.json();
              }).then( handle => {
                console.log(handle);
  
                $.each( handle.variants, function( key, value ) {
                  if(value.id == selectval ){
                    $.each( value.selling_plan_allocations, function( key, selplan ) {
                      console.log(sellingplan);
                      console.log(selplan.selling_plan_id);
                       if(selplan.selling_plan_id == sellingplan ){
                          formData = {
                             'items': [{
                              'id': selectval,
                              'quantity': 1,
                              'selling_plan':sellingplan
                              }]
                            };
                         return false;
                       }else{
                          formData = {
                             'items': [{
                              'id': selectval,
                              'quantity': 1
                              }]
                            };                       
                       }
                    })
                  }
                });
                
              })
              .finally(() =>{
                console.log(formData)
  
                        fetch(window.Shopify.routes.root+'cart/add.js', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(formData)
                        })
                        .then(response => {
                          // console.log(response)
                          return response.json();
                        }).then( results => {
        
                            $.ajax({
                              type:'GET',
                              dataType: 'html',
                              success: function(response2){
                                publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId:selectval,
                                cartData: response2,
                                });
                              }
                            });                                        
                        })
                        .catch((error) => {
                          console.error('Error:', error);
                        }); 
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
                
              })
        }
  });
  
  
  $(document).on('click','.CustomMinus',function(e){
  e.preventDefault();
  let formData;
  var MapVariantId =  $(this).parents('.cart-quantity').attr('data-id');
  var getval = $(this).parents('.cart-quantity').children('.VariantOptions').children('.objectWrapElem').children('.CustomCartvarinat:visible').prev().attr('value');
    if(typeof getval !== 'undefined'){
      $(this).parents('.cart-quantity').children('.VariantOptions').children('.objectWrapElem').children('.CustomCartvarinat').hide();
      $(this).parents('.cart-quantity').find('.VariantOptions').children('.objectWrapElem').children('.CustomCartvarinat[value="'+getval+'"]').show();     
      var custom = '';
      $(this).parents('.cart-quantity').find(".CustomVariantstxt").each(function () {
      var getatt = $(this).find('.Custonvariantoptions:visible').attr('value');
      custom += getatt + ' / ';
    });  
         
          var slicevalue = custom.slice(0,-2).trim();
          var selectval =  $(this).parents('.cart-quantity').find('.SelectedVariants option[data-title="'+slicevalue+'"]').val();
          var ProductHandle = $(this).attr('data-url');
          var sellingplan =   $(this).parents('.cart-quantity').attr('selleing-id');
          
              let updates = { [MapVariantId]: 0};
              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              })
              .then(response => {
                return response.json();
              })
              .finally(() =>{
                
              fetch(window.Shopify.routes.root + 'products/'+ProductHandle+'.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(productJson => {
                return productJson.json();
              }).then( handle => {
                console.log(handle);
  
                $.each( handle.variants, function( key, value ) {
                  if(value.id == selectval ){
                    $.each( value.selling_plan_allocations, function( key, selplan ) {
                      console.log(sellingplan);
                      console.log(selplan.selling_plan_id);
                       if(selplan.selling_plan_id == sellingplan ){
                          formData = {
                             'items': [{
                              'id': selectval,
                              'quantity': 1,
                              'selling_plan':sellingplan
                              }]
                            };
                         return false;
                       }else{
                          formData = {
                             'items': [{
                              'id': selectval,
                              'quantity': 1
                              }]
                            };                       
                       }
                    })
                  }
                });
                
              })
              .finally(() =>{
                console.log(formData)
  
                        fetch(window.Shopify.routes.root+'cart/add.js', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(formData)
                        })
                        .then(response => {
                          // console.log(response)
                          return response.json();
                        }).then( results => {
        
                            $.ajax({
                              type:'GET',
                              dataType: 'html',
                              success: function(response2){
                                publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId:selectval,
                                cartData: response2,
                                });
                              }
                            });                                        
                        })
                        .catch((error) => {
                          console.error('Error:', error);
                        }); 
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
                
              })
        }
  });
  
  $(document).on('click','.custom-media__poster-button .icon-play', function(){
    $('.CustomTitleSet .title-wrapper h2').hide();   
  });
  var getattrs = $('deferred-media').children('template').html();
 
  $(document).on('click','.custom-media__poster-button', function(){
    var getattr = $(this).parents('deferred-media').append($(this).parents('deferred-media').children('template').html());    
  });
  $(document).on('click','.nutrition',function(){
    $('.PopupIngredient h2').hide();
    $('.Pop_UpBox img').show();
    var getattr = $(this).attr('data-image');
    $('.Pop_UpBox img').attr('src', getattr);
    $('.CustomPop_up').addClass('PopUp_Active');
    $('body').addClass('Open_popup');
  });
  
  $(document).on('click','.Cross_Popup',function(){
    $('.CustomPop_up').removeClass('PopUp_Active');
    $('body').removeClass('Open_popup');
  });
  
  $(document).on('click','.ingredient',function(){
    $('.Pop_UpBox img').hide();
    $('.PopupIngredient h2').show();
    var getingre = $(this).attr('data-image-ingredient');
    $('.PopupIngredient h2').html(getingre);
    $('.CustomPop_up').addClass('PopUp_Active');
    $('body').addClass('Open_popup');
  });
  
  
  
  setTimeout(function(){
   const myInterval = setInterval(myTimer, 1000);
  
  function myTimer() {
      var $element = $('.reviews_btn_wrapp .oke-sr-count-number');
    var elementText = $element.text();
    var parts = elementText.split(',');
    var partBeforeComma = parts[0];
    var partAfterComma = parts[1];
   $element.html(partBeforeComma+ ', ' + partAfterComma);
     clearInterval(myInterval);
  }
    }, 1200);
  
  $(document).on('change', '.delivery_dropdown', function () {
      var selectedOption = $(this).find('option:selected').attr('price');
      
      if (selectedOption !== undefined) {
          var checkedInput = $(this).closest('form').find('.skio-group-container input:checked');
          
          if (checkedInput.length > 0) {
              checkedInput.closest('.skio-group-container').find('.price_data_main').html(selectedOption);
          }
      }
  });

 var firstScroll = true;
    $(window).scroll(function() {
        if (firstScroll) {
             var allDivsHtml= '';
            $('.homepagepage-video').each(function() {
                var datadrc = $(this).attr('data-src');
              $(this).find('.homeVideoCnt').html('<iframe id="video" width="560" height="315" src="' + datadrc + '" loading="lazy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>');
                 
                 
            });
           
            firstScroll = false;
        }
    });


});
  
